/** Deep-link to Stock POS sales order detail (Employee Portal). */

function resolveStockAppBaseUrl(): string {
  if (typeof window === "undefined") {
    return "http://localhost:3002";
  }
  const { hostname, protocol } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:3002";
  }
  if (hostname.endsWith("freedombrand.local")) {
    return `${protocol}//stock.freedombrand.local:3002`;
  }
  return "https://stock.freedombrand.la";
}

export function getStockOrderDetailUrl(orderId: string): string {
  return `${resolveStockAppBaseUrl()}/app/orders/${orderId}`;
}
